const formaPagamentoContrato = [
  { text: 'Boleto', value: 0 },
  { text: 'Cartão de Crédito', value: 1 },
  { text: 'Pix', value: 2 },
];

export default formaPagamentoContrato;
